import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController, Platform, SegmentValue } from '@ionic/angular';
import { SegmentChangeEventDetail } from '@ionic/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { HeaderService } from 'src/app/_services/header.service';
import { HeaderModel } from '../../_component/header/header.model';
import { UserService } from '../../_services';
import { ThisPlatform } from '../../_services/platform.service';
import { ReportConfigService } from '../report/report-config/report-config.service';
import { Community, CommunityType } from './community.model';
import { CommunityService } from './community.service';
@Component({
  selector: 'app-community',
  templateUrl: './community.page.html',
  styleUrls: ['./community.page.scss'],
})
export class CommunityPage implements OnInit {
  constructor(
    public communityService: CommunityService,
    public userServ: UserService,
    public p: ThisPlatform,
    private router: Router,
    public alertController: AlertController,
    public translateService: TranslateService,
    public reportConfigServ: ReportConfigService,
    private activatedRoute: ActivatedRoute,
    private headerServ: HeaderService
  ) {}

  type = CommunityType;
  currentSegment: SegmentValue;
  permissionAdd = false;
  permissionAdmin = false;

  showSpinnerLoading = true;

  rowsVisibleInitCount = 5;
  rowsAddVisible = 5;

  communitiesVisible: Community[] = [];

  allCommunitiesVisible = false;

  eventsSubject: Subject<void> = new Subject<void>();

  segmentsArray = [];

  headerInit: HeaderModel = {
    title: 'COMMUNITY.COMMUNITY',
    segmentsChangeFunc: (event) => this.segmentChanged(event),
    segments: [
      {
        name: 'COMMUNITY.INFORMATION',
        value: CommunityType.Information.toString(),
        permissionKeys: ['community.segment.information'],
      },
      {
        name: 'COMMUNITY.EVENTS',
        value: CommunityType.Events.toString(),
        permissionKeys: ['community.segment.events'],
      },
      {
        name: 'COMMUNITY.BOARD',
        value: CommunityType.Board.toString(),
        permissionKeys: ['community.segment.board'],
      },
    ],
    visibility: false,
  };

  @ViewChild('searchBar')
  searchBar;

  async ngOnInit() {
    await this.userServ.getPermision();

    this.headerInit.segments.forEach((segment) => {
      if (this.userServ.hasRoles(segment.permissionKeys)) {
        this.segmentsArray.push(segment.value);
      }
    });

    this.activatedRoute.queryParamMap.subscribe((p) => {
      if (p.get('section')) {
        const page = p.get('section');
        if (this.segmentsArray.filter((el) => el === page).length > 0) {
          this.currentSegment = page;
          this.refreshCommunities();
        } else {
          this.currentSegment = this.segmentsArray[0];
          this.setQueryParam();
        }
      } else {
        this.currentSegment = this.segmentsArray[0];
        this.setQueryParam();
        this.headerServ.setHeaderInit(this.headerInit);
      }

      const id = this.communityService.getIdNavigation();

      if (id) {
        this.navigate(id);
      }
    });
  }

  ionViewWillEnter() {
    this.headerInit.activeSegment = this.currentSegment + '';
    this.headerServ.setHeaderInit(this.headerInit);
  }

  refreshCommunities() {
    this.checkPermission();
    this.communityService
      .getComunitiesType(Number(this.currentSegment))
      .subscribe((res: Community[]) => {
        this.communityService.communities = res;
        this.communityService.communitiesFilter = res;
        this.searchCommunity();
      });
  }

  checkPermission() {
    if (this.currentSegment) {
      if (this.currentSegment === CommunityType.Information.toString()) {
        this.permissionAdd = this.userServ.hasRoles([
          'community.information.add',
        ]);
      } else if (this.currentSegment === CommunityType.Events.toString()) {
        this.permissionAdd = this.userServ.hasRoles(['community.events.add']);
      } else if (this.currentSegment === CommunityType.Board.toString()) {
        this.permissionAdd = this.userServ.hasRoles(['community.board.add']);
      }
    }

    this.permissionAdmin = this.userServ.hasRoles(['community.admin']);
  }

  navigate(id) {
    setTimeout(() => {
      document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
    }, 500);
  }

  communityForm() {
    this.router.navigateByUrl('/community-form');
  }

  segmentChanged(event: CustomEvent<SegmentChangeEventDetail>) {
    this.currentSegment = event.detail.value;
    this.setQueryParam();
  }

  searchbar() {
    this.searchCommunity();
  }

  searchCommunity() {
    if (this.searchBar.ngModel && this.searchBar.ngModel.length > 0) {
      this.communityService.communitiesFilter = this.communityService.communities.filter(
        (item) => {
          if (this.currentSegment === '3') {
            return (
              item.userCreated.firstName +
              ' ' +
              item.userCreated.lastName +
              ' ' +
              item.title +
              ' ' +
              (item.description ? item.description : '')
            )
              .toUpperCase()
              .includes(this.searchBar.ngModel.toUpperCase());
          } else {
            return (
              item.companyCreated.name +
              ' ' +
              item.title +
              ' ' +
              (item.description ? item.description : '')
            )
              .toUpperCase()
              .includes(this.searchBar.ngModel.toUpperCase());
          }
        }
      );
    } else {
      this.communityService.communitiesFilter = this.communityService.communities;
    }

    const rows = this.communityService.communitiesFilter;

    if (rows.length > this.rowsVisibleInitCount) {
      this.communitiesVisible = rows.slice(0, this.rowsVisibleInitCount);
      this.allCommunitiesVisible = false;
    } else {
      this.communitiesVisible = rows;
      this.allCommunitiesVisible = true;
    }
  }

  showMoreRows(): boolean {
    const from = this.communitiesVisible.length;
    let to = from + this.rowsAddVisible;
    const length = this.communityService.communitiesFilter.length;

    if (to >= length) {
      to = length;
      this.allCommunitiesVisible = true;
    }

    for (let i = from; i < to; i++) {
      const row = this.communityService.communitiesFilter[i];
      this.communitiesVisible.push(row);
    }

    return !this.allCommunitiesVisible;
  }

  loadCommunities(event) {
    if(this.allCommunitiesVisible) { 
      event.target.complete();
      return;
    }
    
    window.setTimeout(() => {
      this.showMoreRows();
      event.target.complete();
    }, 500);
  }

  setQueryParam() {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        section: this.currentSegment,
      },
    });
  }
  scrollToInput(event: boolean) {
    if (document.activeElement && event) {
      document.activeElement.scrollIntoView();
    }
  }
}
